import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import { FmIcon } from "../../../Components";
import { useTheme } from "../../../Hooks";

import useStyles from "./BottomDrawer.style";

interface BottomDrawerProps {
    imgUrl: any;
    children: React.ReactNode;
    //here he get 4 function (onRename, onDuplicate, onDeletem, onMessage)
}

const BottomDrawer = ({ children, imgUrl }: BottomDrawerProps) => {
    const [state, setState] = React.useState(false);
    const theme = useTheme();
    const classes = useStyles();

    const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        if (event.type === "keydown" && ((event as React.KeyboardEvent).key === "Tab" || (event as React.KeyboardEvent).key === "Shift")) {
            return;
        }

        setState(open);
    };

    const list = () => (
        <Box
            sx={{
                width: "100%",
            }}
            role='presentation'
            className={classes.more_container}
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
            {children}
        </Box>
    );

    return (
        <div>
            <React.Fragment>
                <div onClick={toggleDrawer(true)}>
                    <FmIcon url={imgUrl} title={"visible"} />
                </div>
                <Drawer anchor='bottom' open={state} onClose={toggleDrawer(false)} className={classes.more_container}>
                    {list()}
                </Drawer>
            </React.Fragment>
        </div>
    );
};

export default BottomDrawer;
